export const testimonials = [
  {
    name: "Marcus T.",
    role: "Fashion Enthusiast",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20warm%20smile%20on%20clean%20white%20background%2C%20natural%20lighting%2C%20simple%20portrait%20photography&width=64&height=64&seq=avatar-marcus-01&orientation=squarish",
    title: "Saved me hours of searching",
    body: "The Hipobuy Spreadsheet completely changed how I browse products. Instead of scrolling through endless pages, I just open the sheet and everything is organized by category. It's honestly the most efficient shopping tool I've ever used.",
    rating: 5,
  },
  {
    name: "Elena R.",
    role: "Online Shopping Expert",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20gentle%20smile%20on%20clean%20white%20background%2C%20natural%20lighting%2C%20simple%20portrait&width=64&height=64&seq=avatar-elena-02&orientation=squarish",
    title: "Best discovery this year",
    body: "I've tried Kakobuy Spreadsheet, CSSBuy Spreadsheet, and Superbuy Spreadsheet, but Hipobuy Sheet really stands out for its organization and ease of use. The category breakdown makes finding specific items incredibly fast. Highly recommend for anyone serious about online shopping.",
    rating: 5,
  },
  {
    name: "David K.",
    role: "Streetwear Collector",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20in%20his%20twenties%20with%20confident%20expression%20on%20clean%20white%20background%2C%20natural%20lighting%2C%20simple%20portrait&width=64&height=64&seq=avatar-david-03&orientation=squarish",
    title: "Finally found what I needed",
    body: "Before discovering Hipobuy Spreadsheet, I was lost in the sea of products. Now I can quickly navigate through jackets, sneakers, and accessories without wasting time. The comparison guides on this site also helped me understand the differences between various spreadsheet platforms.",
    rating: 5,
  },
  {
    name: "Sophie L.",
    role: "Lifestyle Blogger",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20warm%20friendly%20smile%20on%20clean%20white%20background%2C%20natural%20lighting%2C%20simple%20portrait&width=64&height=64&seq=avatar-sophie-04&orientation=squarish",
    title: "My go-to resource",
    body: "I recommend Hipobuy Spreadsheet to all my readers. The guides are well-written, the category system is intuitive, and the comparison tables make it easy to choose the right spreadsheet for your needs. Whether you use Hipobuy, Kakobuy, or Oopbuy, this hub has everything covered.",
    rating: 5,
  },
  {
    name: "James W.",
    role: "Product Researcher",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20friendly%20expression%20on%20clean%20white%20background%2C%20natural%20lighting%2C%20simple%20portrait&width=64&height=64&seq=avatar-james-05&orientation=squarish",
    title: "Incredibly well organized",
    body: "The spreadsheet structure is logical and the regular updates keep everything fresh. I particularly appreciate the safety guides and beginner tutorials available on this hub. It's clear the team behind Hipobuy Spreadsheet genuinely cares about user experience.",
    rating: 5,
  },
  {
    name: "Olivia M.",
    role: "Fashion Student",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20bright%20smile%20on%20clean%20white%20background%2C%20natural%20lighting%2C%20simple%20portrait&width=64&height=64&seq=avatar-olivia-06&orientation=squarish",
    title: "Perfect for beginners",
    body: "As someone new to spreadsheet shopping, I was intimidated at first. But the Hipobuy Sheet beginner guides made everything so simple. The step-by-step tutorials and FAQ section answer every question you could possibly have. This hub is a lifesaver for newcomers.",
    rating: 4,
  },
];